import { BonusItem, BonusItemType } from "@/models/bonus-items.model";
import apiClient from "./apiClient";

export async function getBonusItems(args: {
  userId: number;
  month: number;
  year: number;
}): Promise<BonusItem[]> {
  const { userId, month, year } = args;
  const res = await apiClient.get(
    `/users/${userId}/bonus-items?month=${month}&year=${year}`
  );
  const data: BonusItem[] = res.data as BonusItem[];
  return data;
}

export async function addBonusItem(args: {
  amount: number;
  type: BonusItemType;
  payslipId?: number;
  userId?: number;
  month?: number;
  year?: number;
}): Promise<BonusItem> {
  const res = await apiClient.post("/bonus-items", {
    ...args,
  });
  const data: BonusItem = res.data as BonusItem;
  return data;
}

export async function deleteBonusItem(id: number): Promise<boolean> {
  const res = await apiClient.delete(`/bonus-items/${id}`);
  return res.data as boolean;
}
